import { Filter } from "bad-words";
import customBadWords from "@/data/badWords.json"; 

class FilterEx extends Filter {
    constructor() {
        super({ 
            emptyList: true
        });

        const wordsArray: string[] = customBadWords.words || [];
        this.list = wordsArray;        
    }

    // Override the check to ensure it ONLY catches whole words
    isProfane(string: string) {
        // 1. Check if the string ends with a space or punctuation. 
        // If it doesn't, the user is still typing the last word, so we skip the check.
        const isUserStillTypingWord = !/[\s\.,!\?;:]$/.test(string);
        
        if (isUserStillTypingWord) {
            return false; 
        }

        return this.list.some(word => {
            // 2. Clean and escape the word from your JSON
            const cleanWord = word.trim();
            if (!cleanWord) return false;
            const escapedWord = cleanWord.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

            // 3. Use the Word Boundary (\b)
            const wordRegex = new RegExp(`\\b${escapedWord}\\b`, 'i');
            
            return wordRegex.test(string);
        });
    }

    /**
     * Replace a word with empty string;
     * @param {string} string - String to replace.
     */
    replaceWordEmptyString(string: string) {
        return string
            .replace(this.regex, '')
            .replace(this.replaceRegex, '');
    }

    /**
     * Evaluate a string for profanity and return an edited version with profane words removed.
     * @param {string} input - String to filter.
     */
    cleanExclude(input: string) {
        const delimiter = this.splitRegex.exec(input);
        if (!input || !delimiter) {
            return input;
        }
        return input
            .split(this.splitRegex)
            .map((word) => {
            return this.isProfane(word) ? this.replaceWordEmptyString(word) : word;
        })
            .join(delimiter[0]);
    }
}

export default FilterEx;